import axios from "./axios";

class LeadService {
  verifyToken = async () => {
    try {
      const response = await axios.post("/lead/websdk/verify_token", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  getProducts = async (category_id) => {
    try {
      const response = await axios.post("/lead/websdk/get_products", {
        category_id,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  getAuthorization = async (category_id, product_id) => {
    try {
      const response = await axios.post("/lead/websdk/get_authorization", {
        category_id,
        product_id,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  leadReport = async (from_date, to_date, search_text) => {
    try {
      const response = await axios.post("/lead/websdk/report", {
        from_date,
        to_date,
        search_text,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new LeadService();
